exports.LAYERTWO = '2';
exports.LAYERTHREE = '3';



// WEBPACK FOOTER //
// ./src/constants/layers.js